import ActorConvertedPopup from './ActorConvertedPopup';

export default ActorConvertedPopup;